<template>
  <div class="sidbar-menu bg-dark">
    <ul class="list-unstyled sidebar-menu">
      <li class="sidebar-menu-item">
        <router-link to="/admin" class="sidebar-link pl-2" exact>
          <i class="fa fa-users font-weight-bold"></i>
          <span class="side-link-name ml-2">Компании</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SideBar',
  data: function () {
    return {
      taskMenuOpen: true,
      financeMenuOpen: false,
      clientsMenuOpen: false
    }
  },
  methods: {
    ...mapActions({
      toggleSidebar: 'TOGGLE_SIDEBAR'
    })
  },
  computed: {
    sidebarHidden () {
      return this.$store.state.appSettings.sidebarHidden
    }
  }
}

</script>

<style lang="scss" scoped>
.sidbar-menu {
  .sidebar-sub-menu-item,
  .sidebar-menu-item {
    .ico, .fa {
      display: inline-block;
      text-align: center;
      width: 25px;
    }
  }
}
</style>
